import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { PriceNotLoaded } from "./components/PriceNotLoaded";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Price = /*#__PURE__*/memo(function (_ref) {
  var className = _ref.className,
    price = _ref.price,
    discount = _ref.discount,
    priceNotLoaded = _ref.priceNotLoaded,
    priceNotLoadedCallback = _ref.priceNotLoadedCallback;
  if (priceNotLoaded) {
    return /*#__PURE__*/React.createElement(PriceNotLoaded, {
      priceNotLoadedCallback: priceNotLoadedCallback,
      "data-t-id": "components-Price"
    });
  }
  if (price) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('price', className, {
        'price--align': discount === null || discount === void 0 ? void 0 : discount.priceWithoutDiscount
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('price__value')
    }, /*#__PURE__*/React.createElement(Text, {
      size: "size1-m"
    }, price.value)), /*#__PURE__*/React.createElement("div", {
      className: cn('price__currency')
    }, /*#__PURE__*/React.createElement(Text, {
      size: "size1-m"
    }, price.currency)), /*#__PURE__*/React.createElement("div", {
      className: cn('price__unit')
    }, (discount === null || discount === void 0 ? void 0 : discount.priceWithoutDiscount) && /*#__PURE__*/React.createElement("div", {
      className: cn('price__sale')
    }, /*#__PURE__*/React.createElement(Text, {
      color: "grey40",
      isCrossedOut: true,
      size: "size5-m"
    }, discount.priceWithoutDiscount, "\xA0", price.currency)), /*#__PURE__*/React.createElement("div", {
      className: cn({
        'price__unit--discount': discount === null || discount === void 0 ? void 0 : discount.priceWithoutDiscount
      })
    }, /*#__PURE__*/React.createElement(Text, {
      color: "grey60",
      size: "size5-m"
    }, price.unit.replace(' ', '&nbsp;')))));
  }
  return null;
});